module.exports = __webpack_public_path__ + "img/mid_5.7da922bb.png";